import React from "react";

const PlaceholderContainer = () => <div />;

export default PlaceholderContainer;
